import { Caption, Grid } from '@design-systems/canvas-ui'
import { AccountCard } from './AccountCard'
import { GearIcon } from '@design-systems/react-icons'
import { useWatch, type Control } from 'react-hook-form'
import ControlledFormField from 'components/form/ControlledFormField'
import { AccountSettingsInputs } from 'account/types'

type Props = {
  control: Control<AccountSettingsInputs>
}

export const PreferencesCard = ({ control }: Props) => {
  const currentBetaTester = useWatch({ control, name: 'betaTester' })

  return (
    <AccountCard
      svg={GearIcon}
      cardHeading="Preferences"
      cardSubheading="Customize your experience."
    >
      <Grid.Container spacing="expanded">
        <Grid.Item size={{ xs: 12, sm: 6 }}>
          <Grid.Container>
            <Grid.Item size={{ xs: 12 }}>
              <Caption below="Try new features before they're widely available. Beta features may change, and you can turn them off anytime.">
                <strong>Beta features</strong>
              </Caption>
            </Grid.Item>
            <Grid.Item size={{ xs: 12 }}>
              <ControlledFormField
                control={control}
                type="switch"
                name="betaTester"
                id="betaFeatures"
                label="Turn on beta features"
                isChecked={currentBetaTester}
              />
            </Grid.Item>
          </Grid.Container>
        </Grid.Item>
        <Grid.Item size={{ xs: 12, sm: 6 }}>
          <ControlledFormField
            control={control}
            type="radios"
            name="appearance"
            id="appearance"
            label="Appearance"
            options={[
              { label: 'System default', value: 'SYSTEM' },
              { label: 'Light', value: 'LIGHT' },
              { label: 'Dark', value: 'DARK' },
            ]}
          />
        </Grid.Item>
      </Grid.Container>
    </AccountCard>
  )
}

export default PreferencesCard
